// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-sider {
  position: relative;
  min-width: 0;
  background: #fff;
  transition: all 0.2s;
}
`, "",{"version":3,"sources":["webpack://./src/components/mainLayout/main.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AACJ","sourcesContent":[".ant-layout-sider {\n    position: relative;\n    min-width: 0;\n    background: #fff;\n    transition: all 0.2s;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
